const ModulesManager = () => import('@/components/SuperAdmin/Modules/ModulesManager')

export default [
	{
		component: ModulesManager,
		name: 'sa-modules-manager',
		path: 'modules'
	}
]
